
// パスワードの表示・非表示切替
$(".iconEye").click(function() {
  // iconの切り替え
  $(this).toggleClass("iconEye iconEye-off");
  
  // 入力フォームの取得
  var input = $("#CustomerPassword");
  // type切替
  if (input.attr("type") == "password") {
    input.attr("type", "text");
  } else {
    input.attr("type", "password");
  }
});